import React from "react";
import * as s from "./pane.module.less"
import cn from "classnames";
const Pane = ({
	children,
	bgColor,
	noPadding = false,
}) => {
	return (
		<div
			className={ cn(s.paneWrapper, {
				[s.noPadding]: noPadding
			}) }
			style={{
				backgroundColor: `${bgColor}`
			}}
		>
			{ children }
		</div>
	)
}
export default Pane
